<template>

  <div class="contentMainDiv">
		<div class="userAllUpdateDiv" style="width:860px;">
			<span style="color:red;">{{importMessage}}</span><br>
			<input type="file" @change="onSelectFile" ref="fileInput">
			<button v-bind:disabled="resVal" type="button" @click="batchUpdate"  class="button"  >一括更新</button>
		</div><br>
		
		<div style="width:920px;display:flex;">
			<div>
				<div class="searchTitleDiv">アカウントID</div>
				<input type="text" v-model="searchAccountId">		
			</div>
			<div style="margin-left:10px;">
				<div class="searchTitleDiv">ユーザ名</div>
				<input type="text" v-model="searchAccountName">		
			</div>
			<div style="margin-left:10px;">
				<div class="searchTitleDiv">会社名</div>
				<input type="text" v-model="searchCompanyName">
			</div>

		</div>
		<div style="width:1240px;">
			<span style="color:red;">{{message}}</span>
			<input type="button" @click="addAccount" style="float: right" value="新規登録" class="button">
			<input type="button" @click="refreshAccount" style="float: right" value="検索" class="button">
			<input type="button" @click="fileDownload" style="float: right" value="出力" class="button">
		</div>
		<div class="table" style="max-height:300px;width:1240px;">
			<table>
				<thead>
					<tr>
						<th @click="sort('userid')">アカウントID{{sortMarkers['userid']}}</th>
						<th @click="sort('name')">名前{{sortMarkers['name']}}</th>
						<th @click="sort('companyname')">会社名{{sortMarkers['companyname']}}</th>
						<th @click="sort('watermark')">ウォーターマーク{{sortMarkers['watermark']}}</th>
						<th @click="sort('isnoticemail')">メール配信{{sortMarkers['isnoticemail']}}</th>
						<th></th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr  v-for="(data) in accountList" :key="data.id">
						<td class="tduserid">{{ data.userid }}</td>
						<td class="tdname">{{ data.name }}</td>
						<td class="tdcompanyname">{{ data.companyname }}</td>
						<td class="tdwatermark">{{ data.watermark }}</td>
						<td class="tdmailnotice">{{ data.isnoticemail == 0 ? '×':'〇' }}</td>
						<td class="tdminicenter"><a href="#" @click.prevent.stop="editAccount( data.id )" >編集</a></td>
						<td class="tdminicenter"><a href="#" @click.prevent.stop="deleteAccountConfirm( data.id, $event )" >削除</a></td>
					</tr>
				</tbody>
			</table>
		</div>
		
		<MsgBox ref="msgBox" v-if="isDelete == true" @returnAction="deleteAccount" message='本当に削除しますか?' :targetElement=targetElement></MsgBox>


		<!--<div v-show="isEdit" style="height:500px;width:800px;background:blue;display: flex;align-items: flex-end; border :solid 1px black;position:absolute;  left:  500px; top: 300px;" class="areadiv" cmanOMat="move">-->
			<div v-show="isEdit"  style="border: solid 2px;position:absolute;  left:  500px; top: 300px;max-height:500px;width:800px;background:#fff;padding:30px;">
				<EditAccount v-if="isEdit == true" :id=editId @setIsEdit="setIsEdit" @setMessage="setMessage" @addRegistedAccountToList = "addRegistedAccountToList" ref="editAccountComp"></EditAccount>
			</div>
		<!--</div>-->

		
		<div v-show="isProgressVisible" style=" border-radius: 5px;border:solid 1px;position:absolute;top:200px;left:200px;width:300px;height:140px;background:#f5f5f5">
		<center>
		{{batchMessage}}
		<br>

			<circle-progress
				v-if="isProgressVisible == true"
				ref="circleProgressComp"
				:is-bg-shadow="true"
				:bg-shadow="{
					inset: true,
					vertical: 2,
					horizontal: 2,
					blur: 4,
					opacity: .4,
					color: '#000000'
				}"
				:size='100'
				:show-percent="true"
				:percent=percent
			/>
		</center>
		</div>
	
	</div>

</template>

<script>
import { onUnmounted, ref, computed } from 'vue'
import accountRepository from '../composables/AccountRepository'
import accountFilter from '../composables/AccountFilter'
import listSort from '../composables/ListSort'
import { useStore } from 'vuex'
import "vue3-circle-progress/dist/circle-progress.css";
import CircleProgress from "vue3-circle-progress";
import watchActionProgress from '../composables/WatchActionProgress'
import { addCmanEvent } from "../cmanObjMove_v091.js";
import EditAccount from "../components/EditAccount";
import MsgBox from "../components/MsgBox";
//import * as Definition from '../api/Definition'


export default ({
  name: 'AccountList',
  components: {CircleProgress, EditAccount, MsgBox},
  setup(){

    addCmanEvent()
    const isEdit = ref( false )
    const editId = ref( -1 )
    const editAccountComp = ref(null)
    const circleProgressComp = ref(null)
    const message = ref("")
    const importMessage = ref("")
    const isDelete = ref(false)
    const delAccountId = ref(0)
    const targetElement = ref(null)
    const msgBox = ref(null)
    const accountList = ref([])
    const file = ref()
    const fileInput = ref(null)
    const sortMarkers = ref({userid:'',name:'',companyname:'',watermark:'',isnoticemail:''})
    
    //GoodsRepositoryモジュールからの変数、メソッドを宣言
    //カテゴリ用データ、商品リスト、商品取得メソッド
    const { getAccount, registBatchAccount, downloadAccountListFile, deleteAccountById } = accountRepository()

    //GoodsFilterモジュールからの変数、メソッドを宣言
    //検索のマッチした商品リスト、検索文字列
    const { matchAccount,searchAccountId,searchAccountName,searchCompanyName } = accountFilter( accountList )

    //GoodsSortモジュールからの変数、メソッドを宣言
    //ソート用メソッド
    const { sort } = listSort( accountList, sortMarkers )
    
    //Vuex使用変数宣言
    const store = useStore()
    
    
    const isProgressVisible = ref(false)
    
    //新規作成ボタン押下時の処理
    const addAccount = () => {
      editId.value = null
      editAccountCompInitialize()
    }

    const editAccount = ( id ) => {
      editId.value = id
      editAccountCompInitialize()
    }

    const editAccountCompInitialize=()=>{
      if(isEdit.value) {
        isEdit.value = false
      }else{
        isEdit.value = true
      }
      if( editAccountComp.value != null ){
          editAccountComp.value.$nextTick(() => {
          isEdit.value = true
        })
      }
    }

    const setIsEdit = ( value ) =>{
      isEdit.value = value
    }

    const setMessage = ( value ) =>{
      message.value = value
    }
    
     //登録したアカウントをリストにセット、EditAccountから呼ばれる
    const addRegistedAccountToList = ( data ) =>{
    
      //更新と新規で処理を分ける
      var findAccount = accountList.value.find( a => a.id == data.id )
      if( findAccount != null ){
        findAccount.userid = data.userid
        findAccount.name = data.name
        findAccount.registdate = data.registdate
        findAccount.password = data.password
        findAccount.role = data.role
        findAccount.watermark = data.watermark
        findAccount.isnoticemail = data.isnoticemail
        findAccount.remark = data.remark
        findAccount.department = data.department
        findAccount.companyname = data.companyname
        
      }else{
        accountList.value.unshift( data )
      }
    }
    
    //削除確認ボックス表示
    const deleteAccountConfirm = (id, e)=>{
      if( !isDelete.value ){
        isDelete.value = true
      }else{
         isDelete.value = false
         if( msgBox.value != null ){
           msgBox.value.$nextTick(() => {
             isDelete.value = true
           })
         }
      }    
      targetElement.value = e.target
      delAccountId.value = id
    }
    
    //削除処理 ここで、削除確認も行う
    const deleteAccount = ( confirmRes ) =>{
      console.log( confirmRes )
      isDelete.value = false
      if( confirmRes == msgBox.value.MSG_BOX_OK){
        deleteAccountById( delAccountId.value, deleteAccountCallback)
      }else{
        delAccountId.value = 0
      }
    }
    
    const deleteAccountCallback = ( result, id )=>{
      if( result != "success"){
        message.value = result
      }else{
        message.value = "削除完了"
        //削除されたデータをリストから削除
        accountList.value = accountList.value.filter( c => c.id != id )
      }
    }


    //検索処理
    const refreshAccount = ()=>{
      message.value = ""
      getAccount( callback )
    }

    //データ取得時のコールバック( AccountRepositoryのgetCodesメソッドに渡す)
    const callback = ( result, data )=>{
      if( result != "success"){
        message.value = result
      }else{
        message.value = "データ取得完了"
        accountList.value = data
      }
    }
    
    
    ///ファイルダウンロード////////////////////////////////////
    const fileDownload = () => {
      percent.value = 0
      console.log("fileDonwload")
      isProgressVisible.value = true
      downloadAccountListFile( callbackDownloadFile, callbackUploadFileProgress )
    }
    
    //一括更新時のファイル送信コールバック
    const callbackDownloadFile = ( result ) => {
      isProgressVisible.value = false
      percent.value = 0
      if( result != "success"){
        message.value = result
      }else{
        message.value = "ユーザ一覧ファイル出力完了"
      }    }
    //////////////////////////////////////////////////////////////
    
    
    ///ファイルアップロード////////////////////////////////////
    let actionId;
    let percent = ref(0)
    
    //一括更新時の登録処理の進捗コールバック(WebSocketを使用)
    const callbackBatchUpdateProgress = ( result, errs, per, status ) => {
      console.log( result )
      
      if( result == "Progress" ){
        percent.value = per
      }else if( status == "Progress" && result == "Close"){
        //importMessage.value = "接続が閉じられました。"
        isProgressVisible.value = false

      }else if( status == "Error"){
        importMessage.value = errs
        isProgressVisible.value = false

      }else if( status == "Success"){
        importMessage.value = "登録完了"
        isProgressVisible.value = false

        //ユーザ情報再検索
        getAccount( callback )
      }else if( status == "UnexpectedError"){
        console.log("UnexpectedError")
        console.log(errs)
        importMessage.value = errs
        isProgressVisible.value = false

      }else{
        importMessage.value = errs

      }

      console.log("percent:" + percent.value)
      
    }
    
    const { watchProgress } = watchActionProgress( callbackBatchUpdateProgress )
    
    let batchMessage = ref("")
    
    //一括更新
    const batchUpdate = async() => {
      percent.value = 0
      batchMessage.value = "ファイルアップロード中"
      
      //ファイルの中身を読み込めるか確認
      let hasError = () =>{ return  file.value.slice(0, 1).text().then(() =>  false ).catch(() =>  true ) }
      var ret = await hasError()
 
      if( ret ){
        importMessage.value = "ファイルが変更されている可能性があります。再度選択して下さい。"
        file.value = null;
        fileInput.value.value = null;
        return
      }

      isProgressVisible.value = true
      registBatchAccount( file.value, callbackBatchUpdate, callbackUploadFileProgress )
    }
    
    //一括更新時のファイル送信時の進捗コールバック
    const callbackUploadFileProgress = ( result ) => {
        console.log( "total:" + result.total )
        console.log( "progress:" + result.loaded )
        
        percent.value =  Math.floor( result.loaded / result.total * 100 )
    }
    
    //一括更新時のファイル送信コールバック
    const callbackBatchUpdate = ( result ) => {
      isProgressVisible.value = false
      percent.value = 0
      batchMessage.value = "更新処理中"
      
      if( circleProgressComp.value != null ){
          circleProgressComp.value.$nextTick(() => {
          console.log( result )
          if( result.indexOf('@') == -1 ){
            message.value = result
            return
          }

          
          const results = result.split('@');
          actionId = results[1]
          console.log( "actionId:" + actionId )
          isProgressVisible.value = true
          //正常に送付出来たら、更新処理の進捗を監視する為のWebSocketを使用
          watchProgress( actionId )
          
        })
      }
      

    }
    

    
    
    const onSelectFile = (e) =>{
        console.log("onSelectFile")
		const files = e.target.files;

		if(files.length === 0) {    // ファイル選択がキャンセルされた時
			resVal.value = false
			file.value = null;
			return;

		}

		file.value = files[0];
		console.log( file )
		resVal.value = true
    }
    
    ////////////////////////////////////////////////////////////////////////////////
    
    
    //Vuexから検索文字列を取得
    searchAccountId.value = store.state.searchAccountId
    searchAccountName.value = store.state.searchAccountName
    searchCompanyName.value = store.state.searchCompanyName

    
    //商品情報取得
    getAccount( callback )
    
    //Unmounted時(別画面への遷移など)、Vuexに検索文字列設定
    onUnmounted(()=>{
      store.commit('setSearchAccountId', searchAccountId.value)
      store.commit('setSearchAccountName', searchAccountName.value)
      store.commit('setSearchCompanyName', searchCompanyName.value)
    })
    
    
    const resVal = computed(()=>{
      console.log( "computed" )
      return file.value == null ? true : false
    })
    
    
    //template上で使用する変数を宣言
    return{
      accountList:matchAccount,
      addAccount,
      searchAccountId,
      searchAccountName,
      searchCompanyName,
      sort,
      isProgressVisible,
      batchUpdate,
      onSelectFile,
      file,
      percent,
      batchMessage,
      isEdit,
      editId,
      setIsEdit,
      editAccount,
      editAccountComp,
      fileDownload,
      message,
      setMessage,
      refreshAccount,
      isDelete,
      deleteAccountConfirm,
      deleteAccount,
      targetElement,
      msgBox,
      addRegistedAccountToList,
      sortMarkers,
      circleProgressComp,
      importMessage,
      resVal,
      fileInput
    }
  }
})

</script>

